<template>
  <v-app>
    <v-app-bar
            dense flat
            color="red"
            dark
            clipped-left
            app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Quality Dashboard</v-toolbar-title>

      <v-spacer></v-spacer>


        <v-btn v-if="$store.state.auth.status.loggedIn" color="red" link to="/logout">
          <v-icon>mdi-lock</v-icon>
        </v-btn>


    </v-app-bar>


    <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
    >
      <SideMenu></SideMenu>
    </v-navigation-drawer>




    <v-content >
      <v-container fluid style="background-color: green">
        <router-view  />
      </v-container>

    </v-content>



    <v-footer color="red" dark app>
      <span >&copy; 2019</span>
      <v-spacer />
      <span> QualityDashboard</span>
    </v-footer>
  </v-app>
</template>

<script>
import SideMenu from './components/templates/block/SideMenu';
//import PlanningComponent from './components/planning/PlanningComponent'

export default {
  name: 'App',

  components: {
    SideMenu,
   // PlanningComponent
  },

  data () {
    return {
      drawer: false
    }
  },
};
</script>

<style >

</style>
